import { User as OidcUser } from 'oidc-client';
import { UserState } from 'redux-oidc';
import { RootState } from '../redux/reducers';
import { AppState } from './state/reducer';
import { OidcUserProfile } from './types';

export const getOidc = (state: RootState): UserState => state.oidc;
export const getAppState = (state: RootState): AppState => state.app;

export const getOidcUser = (state: RootState): OidcUser | undefined => {
  const oidc = getOidc(state);
  return oidc.user;
};

export const isAutheticated = (state: RootState): boolean => {
  const oidcUser = getOidcUser(state);
  return !!oidcUser && !oidcUser.expired;
};

export const getIsLoadingUser = (state: RootState): boolean => {
  const oidc = getOidc(state);
  return oidc.isLoadingUser;
};

export const getUserName = (state: RootState): string => {
  const oidcUserProfile: OidcUserProfile = getOidcUser(state)?.profile;
  return oidcUserProfile
    ? `${oidcUserProfile.erecruit_first_name} ${oidcUserProfile.erecruit_last_name}`
    : '';
};

export const getLoggedInMode = (state: RootState): number => {
  const oidcUserProfile: OidcUserProfile = getOidcUser(state)?.profile;

  return oidcUserProfile ? Number(oidcUserProfile.erecruit_logged_in_mode) : -1;
};

export const getLoggedUserId = (state: RootState): number => {
  const oidcUserProfile: OidcUserProfile = getOidcUser(state)?.profile;

  return oidcUserProfile ? Number(oidcUserProfile.erecruit_logged_in_id) : -1;
};

export const getLoggedUserGuid = (state: RootState): string => {
  const oidcUserProfile: OidcUserProfile = getOidcUser(state)?.profile;

  return oidcUserProfile?.sub;
};
